import { Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useRequireAuth } from '../hooks/useRequireAuth';

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
    const { isLoading, shouldRedirect } = useRequireAuth();

    // Show loading state while checking authentication
    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    // Redirect unauthenticated users immediately, before any child components load
    if (shouldRedirect) {
        return <Navigate to="/" replace />;
    }

    // Only render children if user is fully authenticated
    return <>{children}</>;
};

export default PrivateRoute;